import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '~/components';
import { useFeatures } from '~/hooks';
import { accountingProviders } from '~/lookups';
import qboIcon from '~/assets/public/qbo-icon.png';
import sageIcon from '~/assets/public/sage-intacct-icon.svg';
import xeroIcon from '~/assets/public/xero-icon.png';

const icons = { qbo: qboIcon, xero: xeroIcon, sage: sageIcon };

const Image = styled.img`
  width: 1rem;
  height: 1rem;
  display: block;
`;

export default function TimeAccountingIndicator({
  accountingProvider,
  accountingConnectionName,
  invoiceNumber,
  isSynced,
}) {
  const features = useFeatures();
  if (!accountingProvider || !isSynced || !invoiceNumber) return null;

  const accountingProviderName = accountingProviders[accountingProvider]?.name ?? accountingProvider;
  const message =
    features.multipleAccountingIntegrations && accountingConnectionName
      ? `This time entry is associated with invoice #${invoiceNumber} in the "${accountingConnectionName}" instance.`
      : `This time entry is associated with invoice #${invoiceNumber} in ${accountingProviderName}.`;

  return (
    <Tooltip message={message}>
      <Image src={icons[accountingProvider]} />
    </Tooltip>
  );
}
